import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import ZoomInIcon from '@mui/icons-material/Add'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles((theme: Theme) => ({
    iconColor: {
        width: '24px',
        height: '24px',
        '&:hover path': {
            fill: '#318AF1',
        },
        '&:hover circle': {
            fill: '#318AF1',
        },
    },
}))

type MapToolZoomInProps = {
    onClickZoomIn?: () => void
}
const MapToolZoomIn = (props: MapToolZoomInProps) => {
    const { t } = useTranslation()
    const classes = useStyles()

    const onClickZoomIn = () => () => {
        props.onClickZoomIn?.()
    }

    return (
        <Paper sx={{ mb: '8px' }}>
            <Tooltip title={t('LABEL.MAP.TOOLS.ZOOM_IN') ?? ''} placement="left">
                <IconButton
                    sx={{ p: '10px', bgcolor: '#fff', borderRadius: '5px', width: '100%' }}
                    aria-label="directions"
                    onClick={onClickZoomIn()}
                >
                    <ZoomInIcon className={classes.iconColor} />
                </IconButton>
            </Tooltip>
        </Paper>
    )
}

export default MapToolZoomIn
